
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  onMounted,
  computed,
  watch,
  nextTick
} from 'vue'

export default defineComponent({
  components: {},
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    contentRight: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const pageData: any = reactive({})

    return {
      ...toRefs(pageData)
    }
  }
})
